module.exports = __webpack_public_path__ + "img/newsImg6-10.03f13a0c.png";